import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OrganisationId } from '@portal-front-end/models';
import { ProductOrganisationId } from 'libs/models/src/lib/products/product-organisation';
import { ProductOrganisationSupplierReference } from 'libs/models/src/lib/products/product-organisation-supplier-reference';
import { Observable } from 'rxjs';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class ProductsOrganisationSupplierReferenceApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PRODUCTS_ORG_SUP_REF_URL = `${this.apiServer}/product-organisation-supplier-reference`;

    getProductOrganisationSupRef(productOrganisationId: ProductOrganisationId): Observable<ProductOrganisationSupplierReference[]> {
        return this.http.get<ProductOrganisationSupplierReference[]>(`${this.PRODUCTS_ORG_SUP_REF_URL}/${productOrganisationId}`);
    }

    deleteProductOrganisationSupRef(productOrganisationId: number, supplierReference: string): Observable<ProductOrganisationSupplierReference[]> {
        return this.http.delete<ProductOrganisationSupplierReference[]>(`${this.PRODUCTS_ORG_SUP_REF_URL}`, {
            params: {
                'productOrganisationId': productOrganisationId.toString(),
                'supplierReference': supplierReference,
            }
        }
        );
    }

    addAlternateProductOrganisationSupRef(organisationId: OrganisationId, productOrganisationId: number, supplierReference: string): Observable<ProductOrganisationSupplierReference[]> {
        return this.http.post<ProductOrganisationSupplierReference[]>(`${this.PRODUCTS_ORG_SUP_REF_URL}`, {
            productOrganisationId: productOrganisationId,
            supplierReference: supplierReference,
        }, {
            params: {
                organisationId: organisationId
            }
        }
        );
    }
}